import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Icon, Tooltip } from "antd";
import { getIsMobileViewport } from "./useIsMobile";
import MobileFooter from "./MobileFooter";
import { getUserPermissions } from "./genericUtils";
// import WhatsappIcon from "../../../features/whatsapp/WhatsappIcon";
// import { isSuperUser } from "./genericUtils";

const NAV_ITEMS = [
  {
    to: "/",
    icon: "home",
    iconClass: "app-sidebar__icon--home",
    label: "Home",
    isActive: (url) => url === "/",
    mobile: true,
    desktop: true,
  },
  {
    to: "/search",
    icon: "search",
    iconClass: "app-sidebar__icon--search",
    label: "Search",
    isActive: (url) => url === "/search",
    mobile: true,
    desktop: true,
  },
  {
    to: "/reports",
    icon: "bar-chart",
    iconClass: "app-sidebar__icon--reports",
    label: "Reports",
    isActive: (url) => url === "/reports" || url.indexOf("/reports/") === 0,
    mobile: true,
    desktop: true,
    className: "sidebar-reports-link",
  },
  // {
  //   to: "/whatsapp",
  //   label: "WhatsApp",
  //   iconClass: "app-sidebar__icon--whatsapp",
  //   isActive: (url) => url === "/whatsapp" || url.indexOf("/whatsapp/") === 0,
  //   mobile: true,
  //   desktop: true,
  //   className: "sidebar-whatsapp-link",
  //   requiresSuperuser: true,
  //   renderIcon: (className) => (
  //     <WhatsappIcon className={className} size={18} />
  //   ),
  // },
  {
    to: "/notification_triggers",
    icon: "sound",
    iconClass: "app-sidebar__icon--broadcast",
    label: "Broadcast",
    isActive: (url) =>
      url === "/notification_triggers" ||
      url.indexOf("/notification_triggers/") === 0,
    mobile: true,
    desktop: true,
    requiredPermission: "can_broadcast_notifications",
  },
  {
    to: "/notification_list",
    icon: "notification",
    iconClass: "app-sidebar__icon--notifications",
    label: "Notifications",
    isActive: (url) => url === "/notification_list",
    mobile: true,
    desktop: true,
  },
];

class CommonSidebar extends Component {
  state = {
    collapsed: true,
    isMobile: getIsMobileViewport(),
  };

  componentDidMount() {
    this.syncBodyClass();
    this.handleResize = () => {
      this.setState({ isMobile: getIsMobileViewport() }, this.syncBodyClass);
    };
    window.addEventListener("resize", this.handleResize);
  }

  componentDidUpdate() {
    this.syncBodyClass();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
    document.body.classList.remove("app-sidebar-expanded");
  }

  syncBodyClass = () => {
    const { collapsed, isMobile } = this.state;
    const isExpanded = !isMobile && !collapsed;
    document.body.classList.toggle("app-sidebar-expanded", isExpanded);
  };

  toggleCollapsed = () => {
    this.setState(
      (prev) => ({ collapsed: !prev.collapsed }),
      this.syncBodyClass
    );
  };

  renderNavItem = (item, url, { showLabel, showTooltip }) => {
    const active = item.isActive(url);
    const iconClass = `app-sidebar__icon${
      item.iconClass ? ` ${item.iconClass}` : ""
    }`;
    const link = (
      <Link
        to={item.to}
        className={item.className || ""}
        aria-label={item.label}
      >
        <span
          className={`app-sidebar__link${
            active ? " app-sidebar__link--active" : ""
          }`}
        >
          {item.renderIcon ? (
            item.renderIcon(iconClass)
          ) : (
            <Icon type={item.icon} className={iconClass} />
          )}
          {showLabel && (
            <span className="app-sidebar__label">{item.label}</span>
          )}
        </span>
      </Link>
    );

    const content = showTooltip ? (
      <Tooltip title={item.label} placement="right">
        {link}
      </Tooltip>
    ) : (
      link
    );

    return (
      <div key={item.to} className="app-sidebar__item">
        {content}
      </div>
    );
  };

  render() {
    const url = window.location.pathname;
    const { collapsed, isMobile } = this.state;
    const userPermissions = getUserPermissions() || [];
    const items = NAV_ITEMS.filter((item) => {
      // if (item.requiresSuperuser && !isSuperUser()) {
      //   return false;
      // }
      if (
        item.requiredPermission &&
        !userPermissions.includes(item.requiredPermission)
      ) {
        return false;
      }
      return isMobile ? item.mobile : item.desktop;
    });

    if (isMobile) {
      return <MobileFooter />;
    }

    return (
      <React.Fragment>
        <aside
          id="sidebar-color"
          className={`app-sidebar app-sidebar--desktop${
            collapsed ? " is-collapsed" : ""
          }`}
        >
          <div className="app-sidebar__header">
            <button
              type="button"
              className="app-sidebar__toggle"
              onClick={this.toggleCollapsed}
              aria-label={collapsed ? "Expand menu" : "Collapse menu"}
              aria-expanded={!collapsed}
            >
              <span className="app-sidebar__toggle-bar" />
              <span className="app-sidebar__toggle-bar" />
              <span className="app-sidebar__toggle-bar" />
            </button>
            {!collapsed && <span className="app-sidebar__brand">SUPROL</span>}
          </div>

          <div className="app-sidebar__nav">
            {items.map((item) =>
              this.renderNavItem(item, url, {
                showLabel: !collapsed,
                showTooltip: collapsed,
              })
            )}
          </div>
        </aside>
        {!collapsed && (
          <button
            type="button"
            className="app-sidebar__backdrop"
            onClick={this.toggleCollapsed}
            aria-label="Close menu"
          />
        )}
      </React.Fragment>
    );
  }
}

export default CommonSidebar;
